export const commentsConstants = {
    GET_COMMENT_LIST_SUCCESS: 'GET_COMMENT_LIST_SUCCESS',
    GET_COMMENT_LIST_FAIL: 'GET_COMMENT_LIST_FAIL',
    GET_NEW_COMMENT_SUCCESS: 'GET_NEW_COMMENT_SUCCESS',
    GET_NEW_COMMENT_FAIL: 'GET_NEW_COMMENT_FAIL',
    GET_DELETE_COMMENT_SUCCESS: 'GET_DELETE_COMMENT_SUCCESS',
    GET_DELETE_COMMENT_FAIL: 'GET_DELETE_COMMENT_FAIL',
    GET_EDIT_COMMENT_SUCCESS: 'GET_EDIT_COMMENT_SUCCESS',
    GET_EDIT_COMMENT_FAIL: 'GET_EDIT_COMMENT_FAIL',
    UPDATE_REACTED_EMOJI: 'UPDATE_REACTED_EMOJI',
    UPDATE_INITIAL_PROPS: 'UPDATE_INITIAL_PROPS',
    OKR_GET_COMMENT_LIST_SUCCESS: 'OKR_GET_COMMENT_LIST_SUCCESS',
    OKR_GET_COMMENT_LIST_FAIL: 'OKR_GET_COMMENT_LIST_FAIL',
    SET_USER_DATA: 'SET_USER_DATA',
    GET_NEW_CONFIDENCE_COMMENT: 'GET_NEW_CONFIDENCE_COMMENT',
    GET_EDIT_CONFIDENCE_COMMENT_FAIL: 'GET_EDIT_CONFIDENCE_COMMENT_FAIL',
    GET_EDIT_CONFIDENCE_COMMENT_SUCCESS: 'GET_EDIT_CONFIDENCE_COMMENT_SUCCESS',
    CLEAR_COMMENT_LIST: 'CLEAR_COMMENT_LIST',
    GET_VIEWABLE_METRIC_IDS_SUCCESS: 'GET_VIEWABLE_METRIC_IDS_SUCCESS',
    GET_VIEWABLE_METRIC_IDS_FAIL: 'GET_VIEWABLE_METRIC_IDS_FAIL',
    WB_WORKER_EMAIL: 'wb-worker@workboard.com'
};